import React, { useEffect, useState } from 'react';
import { useInView } from 'react-intersection-observer';
import { jsx as _jsx } from "react/jsx-runtime";
export function IFrame({
  src,
  title,
  lazy,
  className,
  isVideo = false,
  ...rest
}) {
  const {
    ref,
    inView
  } = useInView({
    triggerOnce: true
  });
  const [lazySource, setLazySource] = useState();
  useEffect(() => {
    if (lazy && inView) {
      setLazySource(src);
    }
  }, [src, inView, lazy]);
  return /*#__PURE__*/_jsx("iframe", {
    ref: ref,
    className: className,
    src: lazy ? lazySource : src,
    title: title,
    ...(isVideo ? {
      frameBorder: '0',
      allowFullScreen: true,
      allow: 'autoplay; fullscreen'
    } : {}),
    ...rest
  });
}